import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/rankings", label: "排行榜" },
  { to: "/reviews", label: "评测推荐" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur border-b border-background-200/70"
          : "bg-background-50/70 backdrop-blur border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">
            漫选<span className="text-primary-500">社</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500 font-bold text-background-50"
                    : "text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:block">
          <Link
            to="/contact"
            className="whitespace-nowrap rounded-full border-2 border-primary-500 px-5 py-2 text-sm font-bold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            联系我们
          </Link>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-950 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-4 py-2.5 text-sm ${
                    isActive ? "bg-primary-500 font-bold text-background-50" : "text-foreground-700 hover:bg-background-200/70"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-bold text-background-50"
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}